// removed by extract-text-webpack-plugin
module.exports = {"srField":"ClaimServiceRequests-hashed__srField__bcuMu","srList":"ClaimServiceRequests-hashed__srList__-76tO","serviceRequest":"ClaimServiceRequests-hashed__serviceRequest__3QR1r","status":"ClaimServiceRequests-hashed__status__TgGcR","label":"ClaimServiceRequests-hashed__label__2MvEc","statusIcon":"ClaimServiceRequests-hashed__statusIcon__1Ifuu","offTrack":"ClaimServiceRequests-hashed__offTrack__2jFL2"};


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/claim/directives/ClaimServiceRequests/ClaimServiceRequests-hashed.scss
// module id = 1160
// module chunks = 0